const AUTH_ACTION = {
  AUTHENTICATE: 'AUTH_AUTHENTICATE',
  AUTHENTICATE_USER: 'AUTH_AUTHENTICATE_USER',
  UPDATE_JWT: 'AUTH_UPDATE_JWT',
  LOG_IN: 'AUTH_LOG_IN',
  LOG_OUT: 'AUTH_LOG_OUT',
  LOG_IN_WITH_FACEBOOK: 'AUTH_LOG_IN_WITH_FACEBOOK',
  LOG_IN_WITH_GOOGLE: 'AUTH_LOG_IN_WITH_GOOGLE',
  LOG_IN_WITH_APPLE: 'AUTH_LOG_IN_WITH_APPLE',
  SIGN_UP: 'AUTH_SIGN_UP',
  VALIDATE_EMAIL_AND_PASSWORD: 'AUTH_VALIDATE_EMAIL_AND_PASSWORD',
  UPDATE_EMAIL: 'AUTH_UPDATE_EMAIL',
  UPDATE_PASSWORD: 'AUTH_UPDATE_PASSWORD',
  UPDATE_TO_LOG_IN: 'AUTH_UPDATE_TO_LOG_IN',
  UPDATE_TO_SIGN_UP: 'AUTH_UPDATE_TO_SIGN_UP',
  UPDATE_AND_VALIDATE: 'AUTH_UPDATE_AND_VALIDATE',
  VALIDATE_RESET_PASSWORD_EMAIL: 'AUTH_VALIDATE_RESET_PASSWORD_EMAIL',
  RESET_STATE: 'AUTH_RESET_STATE'
}

export default AUTH_ACTION
